export default "__VITE_ASSET__DNqyS$by__ 720w";